var _stop, _stop2, _feOffset, _feGaussianBlur, _feColorMatrix, _feMerge, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";

function SvgButtonsRoundedYoutubeRed(props) {
  var _id2 = useUniqueInlineId();

  var _id = useUniqueInlineId();

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      borderRadius: 20
    }
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "73.162%",
    y1: "7.565%",
    x2: "22.6%",
    y2: "87.141%",
    id: _id
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1",
    offset: "0%"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C27",
    offset: "99.918%"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-145.1%",
    y: "-145.1%",
    width: "390.2%",
    height: "390.2%",
    filterUnits: "objectBoundingBox",
    id: _id2
  }, _feOffset || (_feOffset = /*#__PURE__*/React.createElement("feOffset", {
    dy: 7,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  })), _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  })), _feColorMatrix || (_feColorMatrix = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.103884397 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  })), _feMerge || (_feMerge = /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#".concat(_id2, ")"),
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    fill: "url(#".concat(_id, ")")
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.203 11.6h.454l1.05.01 1.121.022c.382.01.77.021 1.159.035l.922.039.648.034.605.038.562.043.516.048.47.052.42.058c.33.05.608.107.829.169 1.208.343 2.152 1.338 2.47 2.596.175.686.3 1.631.386 2.765l.047.703.04.809.028.775.015.721.005.523-.006.508-.02.855a50.46 50.46 0 01-.06 1.373l-.03.469-.036.457c-.086 1.047-.206 1.915-.368 2.554-.323 1.262-1.268 2.258-2.473 2.597a8.248 8.248 0 01-1.1.207l-.478.057-.53.051-.583.047-.63.04-.679.037a76.195 76.195 0 01-1.52.06l-1.145.028-1.096.016-.52.004-.826-.002-.921-.011-.982-.021-1.017-.031-.864-.035-.984-.053-.602-.04-.555-.046-.508-.05-.458-.057-.407-.061a6.423 6.423 0 01-.653-.14c-1.209-.344-2.153-1.339-2.472-2.597a12.123 12.123 0 01-.256-1.445l-.065-.584-.056-.631a52.342 52.342 0 01-.135-2.943l-.006-.413v-.389l.003-.334.015-.722.027-.774.04-.809.048-.703c.086-1.134.211-2.08.385-2.765.323-1.262 1.268-2.258 2.473-2.597.177-.05.39-.095.637-.137l.395-.06.217-.029.47-.052.516-.048.561-.043.606-.038.647-.034.34-.016c.387-.016.778-.03 1.164-.042l1.145-.029 1.09-.016.515-.003zm-2.457 14.136v-9.472L25.787 21l-8.041 4.736z",
    fill: "#FFF",
    stroke: "#FFF",
    strokeWidth: 0.8
  }))));
}

export default SvgButtonsRoundedYoutubeRed;